<template>
  <div ref="listFilters" v-sticky="sticky" class="list__filter">
    <div
      ref="listFilterInner"
      class="list__filter__inner"
      :class="{ 'list__filter--open': filtersOpen }"
      data-v-sticky-inner
    >
      <div
        class="list__filter__accessor d-flex d-md-none align-center justify-space-between pt-1 pr-1"
      >
        <p class="list__filter__accessor__label pl-1 pr-1 mb-0 text-secondary">
          <strong>{{ $t('action.filter') }}</strong>
        </p>

        <PrimaryButton
          :text="$t('action.close')"
          with-arrow
          arrow-is-icon
          icon="cross"
          text-visually-hidden
          no-shadow
          class="list__filter__accessor__close"
          @click="filtersOpen = false"
        />
        <PrimaryButton
          :text="$t('action.filter_go_to')"
          with-arrow
          arrow-is-icon
          icon="filter"
          text-visually-hidden
          no-shadow
          class="list__filter__accessor__filter"
          @click="goToFilters"
        >
          <template #after>
            <span
              v-if="countFilters > 0"
              class="list__filter__accessor__count"
              >{{ countFilters }}</span
            >
          </template>
        </PrimaryButton>
      </div>

      <div ref="listFilterBlocks" class="list__filter__content">
        <!-- <div class="list__filter__blocks pt-md-1">
           <filter-toggle
            v-model="selectedPageSize"
            name="pageSize"
            :values="pageSizes"
            :translate-label="false"
            @input="updateDisplay()"
          /> 

           <filter-toggle
            v-model="selectedListDisplay"
            name="listDisplay"
            :values="listDisplay"
            @input="updateDisplay()"
          /> 
        </div> -->

        <div class="list__filter__blocks">
          <div
            class="d-none d-md-flex justify-space-between align-center pt-1 mb-0-6"
          >
            <h2 class="h4 d-none d-md-block mb-0 pl-1 pl-md-0 pr-1 pr-md-0">
              {{ $t('search.filter.title') }}
            </h2>

            <button-link
              with-icon
              icon="reduce"
              icon-position="right"
              @click="requestReduce"
            >
              <span class="text-extra-small text-uppercase w-500">{{
                $t('action.reduce')
              }}</span>
            </button-link>
          </div>

          <filter-default
            v-if="filters.product_type"
            ref="category"
            v-model="selectedFilter.productType"
            with-icon
            name="category"
            :filters="filters.product_type"
            :updated-at="updatedAt"
            @input="update('category')"
          />

          <filter-default
            v-if="filters.sizes"
            ref="size"
            v-model="selectedFilter.sizes"
            with-icon
            name="size"
            :filters="filters.sizes"
            multiple
            :disabled="!hasProductType"
            :disabled-info="
              !hasProductType ? $t('search.filter.wait_for_category') : ''
            "
            :updated-at="updatedAt"
            @validate="update('size')"
          />

          <transition name="fade">
            <div v-if="oneFiltersHasBeenSet" class="list__filter__actions">
              <a
                href="#"
                class="link-unroll text-small text-secondary text-md-primary text-center d-block mt-md-1 pl-1 pl-md-0 pr-1 pr-md-0"
                @click.prevent="reset"
                >{{ $t('search.filter.all_reset') }}</a
              >
            </div>
          </transition>

          <!--
        <filter-default
          v-model="selectedFilter.price"
          name="price"
          :filters="filters.prices"
          :facet-loading="onRefresh"
          @input="filterList(true)"
        /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NuxtSSRScreenSize from 'nuxt-ssr-screen-size'
import { mapMutations } from 'vuex'

import FilterDefault from '@/components/filter/Default'
// import FilterToggle from '@/components/filter/Toggle'
import ButtonLink from '@/components/buttons/Link'
import PrimaryButton from '@/components/buttons/Primary'

export default {
  name: 'DefaultFilters',
  components: {
    FilterDefault,
    // FilterToggle,
    ButtonLink,
    PrimaryButton,
  },
  mixins: [NuxtSSRScreenSize.NuxtSSRScreenSizeMixin],
  props: {
    sliceId: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    numberOfProducts: {
      type: Number,
      default: 0,
    },
    display: {
      type: Object,
      default: () => ({}),
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => {
    return {
      updatedAt: 0,
      selectedFilter: {
        productType: [],
        sizes: [],
      },
      selectedPageSize: 10,
      selectedListDisplay: 'grid',
      pageSizes: [
        { value: 10, label: '10' },
        { value: 25, label: '25' },
        { value: 50, label: '50' },
      ],
      listDisplay: [
        { value: 'grid', label: 'search.display.listDisplay.grid' },
        { value: 'list', label: 'search.display.listDisplay.list' },
      ],
      filtersOpen: true,
      sticky: {
        containerSelector: '[data-v-sticky-container]',
        innerWrapperSelector: '[data-v-sticky-inner]',
        resizeSensor: true,
        topSpacing: 0,
        minWidth: 0,
      },
    }
  },
  computed: {
    hasProductType() {
      return Object.keys(this.selectedFilter.productType).length > 0
    },
    oneFiltersHasBeenSet() {
      return this.hasProductType || this.selectedFilter.sizes.length > 0
    },
    countFilters() {
      const routeQuery = this.$route.query
      const routeProductType = routeQuery.productType || ''
      const routeSizes = routeQuery.sizes || []

      let count = 0

      if (routeProductType && routeProductType !== '') {
        count += 1
      }

      if (Array.isArray(routeSizes)) {
        if (routeSizes.length > 0) {
          count += routeSizes.length
        }
      } else if (routeSizes && routeSizes !== '') {
        count += 1
      }

      return count
    },
  },
  created() {
    if (this.display.pageSize) {
      this.selectedPageSize = this.display.pageSize
    }
  },
  mounted() {
    this.setRouteParamsToFilters(this.$route)

    this.$nuxt.$on('reset-filters', this.reset)
    this.$nuxt.$on('filter-updated', this.filtersUpdated)
  },
  beforeDestroy() {
    this.$nuxt.$off('reset-filters', this.reset)
    this.$nuxt.$off('filter-updated', this.filtersUpdated)
  },
  methods: {
    ...mapMutations({
      addSliceToHide: 'behavior/ADD_SLICE_TO_HIDE',
      cleanSliceToHide: 'behavior/CLEAN_SLICE_TO_HIDE',
      setScroll: 'behavior/SET_SCROLL',
    }),
    setRouteParamsToFilters($route) {
      if (Object.keys($route.query).length > 0) {
        if ($route.query.productType && this.filters.product_type) {
          const productType = this.filters.product_type.find(
            (p) => p.label === $route.query.productType
          )

          if (productType) {
            this.selectedFilter.productType = productType
          }
        } else {
          this.selectedFilter.productType = {}
        }

        if ($route.query.sizes && this.filters.sizes) {
          const sizes = this.filters.sizes.filter((s) => {
            if (Array.isArray($route.query.sizes)) {
              // eslint-disable-next-line
              return $route.query.sizes.some((qs) => qs === s.label)
            }
            return $route.query.sizes === s.label
          })

          this.selectedFilter.sizes = sizes
        } else {
          this.selectedFilter.sizes = []
        }
      }
    },
    update(from) {
      if (!this.hasProductType || from === 'category') {
        this.selectedFilter.sizes = []
      }

      this.$emit(
        'update',
        {
          productType: this.hasProductType
            ? this.selectedFilter.productType.label
            : null,
          sizes: this.selectedFilter.sizes.map((s) => s.label),
        },
        from !== 'route',
        from !== 'route',
        from
      )

      if (from === 'category') {
        this.$nextTick(() => {
          if (this.$refs.category && this.$refs.size) {
            this.$refs.category.toggleOpen(false, false)
          }
        })
      }

      if (from === 'size') {
        this.$nextTick(() => {
          this.$refs.category.toggleOpen(false, false)
          this.$refs.size.toggleOpen(false, false)
        })

        this.filtersOpen = false
      }
    },
    updateDisplay() {
      this.$emit('updateDisplay', {
        pageSize: this.selectedPageSize,
        listDisplay: this.selectedListDisplay,
      })
    },
    reset() {
      this.selectedFilter.productType = {}
      this.selectedFilter.sizes = []
      this.update('reset')

      this.$nextTick(() => {
        if (this.$refs.category && this.$refs.size) {
          this.$refs.category.toggleOpen(false, false)
          this.$refs.size.toggleOpen(false, false)
        }
      })
    },
    filtersUpdated(arg) {
      this.updatedAt = Date.now()

      if (arg && arg.fromFilter && arg.fromFilter === 'category') {
        this.$refs.size.toggleOpen(this.hasProductType, false)
      }
    },
    async goToFilters() {
      if (!this.filtersOpen) {
        this.filtersOpen = true
        return
      }

      const { gsap } = await import('gsap' /* webpackChunkName: 'gsap' */)
      const { ScrollToPlugin } = await import(
        'gsap/ScrollToPlugin' /* webpackChunkName: 'gsap_scroll_to_plugin' */
      )
      gsap.registerPlugin(ScrollToPlugin)
      this.setScroll(true)

      gsap.to(window, {
        scrollTo: {
          y: this.$refs.listFilters,
          offsetY: 0,
        },
        duration: 0.7,
        onComplete: () => {
          this.setScroll(true)
        },
      })
    },
    /*
    async showFilter() {
      const { gsap } = await import('gsap')

      const filters = this.$refs.listFilter
      const filterInner = this.$refs.listFilterInner
      const topPosition = filterInner.getBoundingClientRect().top

      filters.style.height = `${filters.offsetHeight}px`
      filterInner.style.top = `${topPosition}px`
      filterInner.classList.add('fixed')

      gsap.to(filterInner, {
        top: 0,
        height: '100vh',
        duration: 0.7,
        ease: 'sine.inOut',
        onComplete: () => {
          const banner = document.getElementById('banner')
          const header = document.getElementById('header')
          const allBlocks = document.getElementsByClassName('blocks')
          const footer = document.getElementById('footer')

          header.classList.add('d-none-i')
          footer.classList.add('d-none-i')

          if (banner) {
            banner.classList.add('d-none-i')
          }

          if (allBlocks) {
            for (const blocks of allBlocks) {
              for (const block of blocks.childNodes) {
                if (block.classList && block.id !== this.sliceId) {
                  this.addSliceToHide(block.id)
                }
              }
            }
          }

          this.$emit('filter-opened')

          this.$nextTick((_) => {
            this.filtersOpen = true
            filterInner.classList.remove('fixed')
            filterInner.classList.add('open')
            filterInner.style = ''
            this.$el.style.marginTop = 0
            this.$el.style.marginBottom = 0
            filters.style.marginBottom = 0

            this.$nextTick((_) => {
              window.scrollTo(0, 0)
            })
          })
        },
      })
    },
    async hideFilters() {
      const { gsap } = await import('gsap')
      const filters = this.$refs.listFilter
      const filterInner = this.$refs.listFilterInner
      const banner = document.getElementById('banner')
      const header = document.getElementById('header')
      const footer = document.getElementById('footer')

      header.classList.remove('d-none-i')
      footer.classList.remove('d-none-i')

      if (banner) {
        banner.classList.remove('d-none-i')
      }

      this.cleanSliceToHide()
      this.$emit('filter-closed')

      this.$el.style.marginBottom = ''
      this.$el.style.marginTop = ''
      filters.style.marginBottom = ''

      filterInner.classList.add('fixed')
      filterInner.classList.add('fixed--top')
      filterInner.classList.remove('open')
      filterInner.style.bottom = ''
      filterInner.style.height = `${window.outerHeight}px`

      this.filtersOpen = false

      this.$nextTick(() => {
        const topPosition = filters.getBoundingClientRect().top
        window.scrollTo(0, topPosition - 6)

        gsap.to(filterInner, {
          height: filters.offsetHeight,
          duration: 0.7,
          ease: 'power2.out',
          onComplete: () => {
            filterInner.classList.remove('fixed')
            filterInner.classList.remove('fixed--top')
          },
        })
      })
    },
    */
    requestReduce() {
      this.$emit('request-reduce')
    },
  },
}
</script>

<style lang="scss">
.list__filter {
  min-height: rem(26px);

  .list__filter__inner {
    @include mq($from: tablet) {
      max-height: 100%;
      overflow: auto;
    }

    .action__inner__open {
      transition: all 0.3s var(--asphalte-animation-function);
    }

    &.fixed {
      position: fixed !important;
      width: 100% !important;
      left: 0 !important;
      right: 0;
      z-index: 3000;
      background: var(--tertiary-color);

      &:not(.fixed--top) {
        .list__filter__accessor {
          .action {
            padding: calc(var(--spacing) * 0.4) 0;
            transition: all 0.3s var(--asphalte-animation-function);
          }
        }
      }

      .action__inner__open {
        transition: all 0.5s var(--asphalte-animation-function);
        opacity: 0;
      }

      &--top {
        top: 0 !important;

        .list__filter__accessor {
          .action {
            margin-top: calc(var(--spacing) * 0.4);
          }
        }
      }
    }

    &.open {
      position: relative;
      background: var(--tertiary-color);
      z-index: 2000;
      display: flex;
      flex-direction: column;

      .list__filter__accessor {
        .action {
          padding: calc(var(--spacing) * 0.4) 0;

          &::before {
            content: none;
          }
        }
      }

      .action__inner__open {
        opacity: 0;
      }

      .list__filter__content {
        display: block;
        animation: appear-left 0.3s;
      }
    }
  }

  .list__filter__actions {
    padding: calc(var(--spacing) * 1) calc(var(--spacing) * 1);

    @include mq($from: tablet) {
      padding: 0;
    }
  }

  .list__filter__accessor {
    .action {
      min-width: rem(38px);
      height: rem(38px);
      border-radius: 38px;
      padding: 0 calc(var(--spacing) * 0.6);

      .icon {
        width: rem(20px);
        height: rem(20px);
      }
    }

    .action__inner {
      justify-content: center;
      padding: 0;
    }

    &__label {
      font-size: rem(24px);
      line-height: rem(18px);
      transition: opacity 0.3s var(--asphalte-animation-function);
    }

    &__close {
      display: none;

      &.action .icon {
        width: rem(14px);
        height: rem(14px);
      }
    }

    &__filter {
      pointer-events: all;
    }

    &__count {
      display: flex;
      width: rem(24px);
      height: rem(24px);
      align-items: center;
      justify-content: center;
      background-color: var(--tertiary-color);
      color: var(--secondary-color);
      border-radius: 50%;
      font-family: var(--primary-font-family);
      font-size: var(--small-font-size);
      line-height: rem(18px);
      font-weight: 600;
      margin-left: calc(var(--spacing) * 0.6);
    }
  }

  .list__filter__content {
    background: var(--tertiary-color);
    transition: all 0.3s var(--asphalte-animation-function);
  }

  &.is-affixed {
    .list__filter__inner {
      z-index: 200;
      transition: padding 0.4s cubic-bezier(0.46, 0.01, 0.32, 1);

      @include mq($from: tablet) {
        margin-left: var(--spacing);

        .header-visible & {
          padding-top: calc(var(--header-height));
        }
      }
    }

    .list__filter__accessor {
      z-index: 300;
      transition: all 0.3s var(--asphalte-animation-function);
      pointer-events: none;

      .action {
        background-color: var(--yellow-color);
        color: var(--secondary-color);
      }

      .header-visible & {
        padding-top: calc(var(--header-height) + var(--spacing));
      }

      .action__inner__text {
        display: none;
      }
    }

    .list__filter__accessor__label {
      opacity: 0;
    }

    .list__filter__accessor__count {
      background-color: var(--secondary-color);
      color: var(--tertiary-color);
    }

    .list__filter__content {
      @include mq($until: tablet) {
        opacity: 0;
        pointer-events: none;
      }
    }

    .list__filter--open {
      .list__filter__accessor__label {
        opacity: 1;
      }

      .list__filter__accessor__close {
        display: block;
      }

      .list__filter__accessor {
        background-color: var(--tertiary-color);
        pointer-events: all;
      }

      .list__filter__accessor__filter {
        display: none;
      }

      .list__filter__content {
        opacity: 1;
        pointer-events: all;
      }
    }
  }
}
</style>
